import { config as reviewConfig } from './review.config';
import { config as aboutYouConfig } from './about-you.config';
import { config as completeConfig } from './complete-page.config';
import { config as selectDateConfig } from './select-date.config';
import { config as pathConfig } from './path.config';
import { EDIT_PROGRESS_BAR_ITEMS, PROGRESS_BAR_ITEMS } from './progress-bar-items.config';
import { getAppointmentsDetails } from './analytics.config';
import { createHeadline } from './headline.config';
import { services } from '../../services.constant';

const questionsSectionsConfig = [
  {
    key: undefined,
    title: 'Additional information',
    dataTest: 'AdditionalInformation',
  },
];

export const config = {
  ...pathConfig,
  ...aboutYouConfig,
  ...reviewConfig,
  ...completeConfig,
  ...selectDateConfig,
  serviceName: services.LINGERIE.name,
  PROGRESS_BAR_ITEMS,
  EDIT_PROGRESS_BAR_ITEMS,
  partnerTitle: 'Lingerie Fitter',
  getAppointmentsDetails,
  isPartnerSelectionEnabled: false,
  questionsSectionsConfig,
  headlineTitle: createHeadline,
};
